type Display2 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const display2: Display2 = {
    'fontFamily': 'var(--plasma-typo-display2-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-display2-font-weight, 500)',
    'fontStyle': 'var(--plasma-typo-display2-font-style, normal)',
    'fontSize': 'var(--plasma-typo-display2-font-size, 3.75rem)',
    'letterSpacing': 'var(--plasma-typo-display2-letter-spacing, -0.0190em)',
    'lineHeight': 'var(--plasma-typo-display2-line-height, 4rem)'
};